var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg72Ms4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03142a;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.64,10.55v1.03c0,.47-.4,.86-.89,.86s-.89-.38-.89-.86v-.17h-1.98s.01,.04,.01,.07v6.46h.89c.39,0,.71,.31,.71,.69s-.32,.69-.71,.69h-3.57c-.39,0-.71-.31-.71-.69s.32-.69,.71-.69h.89v-6.46s.01-.04,.01-.07h-1.98v.17c0,.47-.4,.86-.89,.86s-.89-.38-.89-.86v-1.03c0-.47,.4-.86,.89-.86h7.5c.49,0,.89,.38,.89,.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.33,
    y: 22.17,
    width: 9.33,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72Ms4);
export default __webpack_public_path__ + "static/media/72-ms-4.4960cee7f170f32ffff4b1ddf5a67c07.svg";
export { ForwardRef as ReactComponent };